module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('transition', {
    attrs: {
      "name": "logo",
      "mode": "out-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "logo",
    class: {
      hover: _vm.revealHeader
    },
    on: {
      "click": _vm.toggleNav,
      "mouseenter": _vm.toggleNavHover,
      "mouseleave": _vm.toggleNavHover
    }
  }, [_c('div', {
    staticClass: "logo-ctn",
    domProps: {
      "innerHTML": _vm._s(_vm.logo)
    }
  }), _c('span', [_vm._v("Menu")])])]), _c('div', {
    staticClass: "indicator"
  }, [_c('router-link', {
    class: {
      hover: _vm.revealHeader
    },
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.headerMouseover($event)
      },
      "mouseleave": function($event) {
        _vm.headerMouseover($event)
      }
    }
  }, [(_vm.indicator !== null) ? _c('transition', {
    attrs: {
      "name": "indicator",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "enter": _vm.indicatorEnter
    }
  }, [_c('div', {
    key: _vm.indicator,
    staticClass: "icon-wrap"
  })]) : _vm._e(), _c('div', {
    staticClass: "icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icon)
    }
  }), _c('span', {
    staticClass: "home-link"
  }, [_vm._v("Home")])], 1)], 1), _c('transition', {
    attrs: {
      "name": "coordinates",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "before-enter": _vm.coordinatesBeforeEnter,
      "enter": _vm.coordinatesEnter
    }
  }, [_c('div', {
    staticClass: "coordinates"
  }, [_c('router-link', {
    class: {
      hover: _vm.revealHeader
    },
    attrs: {
      "to": "/kontakt"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.headerMouseover($event)
      },
      "mouseleave": function($event) {
        _vm.headerMouseover($event)
      }
    }
  }, [_c('span', [_vm._v("48° 12' 30 N"), _c('br'), _vm._v("16° 22' 19 "), _c('span', [_vm._v("E")])]), _c('span', {
    staticClass: "contact-link"
  }, [_vm._v("Kontakt")])]), _c('router-link', {
    staticClass: "icon",
    attrs: {
      "to": "/kontakt"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contact)
    }
  })], 1)]), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44487cce"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 424
// module chunks = 1